import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const notificationApi = createApi({
  reducerPath: "notificationApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: () => "/Notification",
    }),
    getUnreadCount: builder.query({
      query: () => "/Notification/unread-count",
    }),
    markAsRead: builder.mutation({
      query: (id) => ({
        url: `/Notification/${id}/read`,
        method: "PUT",
      }),
    }),
    markAllAsRead: builder.mutation({
      query: () => ({
        url: "/Notification/read-all",
        method: "PUT",
      }),
    }),
    deleteNotification: builder.mutation({
      query: (id) => ({
        url: `/Notification/${id}`,
        method: "DELETE",
      }),
    }),
    deleteAllNotifications: builder.mutation({
      query: () => ({
        url: "/Notification",
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useGetUnreadCountQuery,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
  useDeleteNotificationMutation,
  useDeleteAllNotificationsMutation,
} = notificationApi;
